// extracted by mini-css-extract-plugin
export default {"filterItemContainer":"SearchDropdown_filterItemContainer__xQTUB","filterType":"SearchDropdown_filterType__WZgzZ","closeIcon":"SearchDropdown_closeIcon__S5as4"};